import React, { memo } from 'react';
import { useGameContext } from "../../libs/GameProvider";
import { DevStateComMap } from '../../libs/GameStateReducer';

function DevPanel() {
  const { game, dispatch } = useGameContext();

  if ('development' !== process.env.NODE_ENV) {
    return <></>;
  }

  return (
    <div className="button-intro-dev">
      <span>{DevStateComMap[game.status]}.tsx <span>[X]</span></span>
      <pre>{JSON.stringify(game, null, 2)}</pre>
      <button onClick={() => dispatch({ type: 'game-cover' })}>Game Cover</button>
      <button onClick={() => dispatch('difficulty-1')}>Easy</button>
      <button onClick={() => dispatch('difficulty-3')}>Hard</button>
      {/* <button onClick={() => dispatch({ type: 'game-index' })}>Game Index</button> */}
      <hr />
      {['game-paper-making', 'game-compass', 'game-printing', 'game-gunpowder'].map((type: any) =>
        <div key={type} style={{ display: 'flex' }}>
          <span>{type}</span>
          {['cover', 'fail'].map((state: any) => <button key={state} onClick={() => dispatch({ type, state })}>{state}</button>)}
          <button onClick={() => dispatch({ type, state: 'success', data: 3 })}>success (3)</button>
        </div>
      )}
      <hr />
      {/* <div style={{ display: 'flex' }}>
        <span>Hints</span>
        <button onClick={() => dispatch({ action: "setHints", hints: 0 })}>Set to 0</button>
        <button onClick={() => dispatch({ action: "addHints" })}>Add</button>
      </div> */}
      <hr />
      {/* <div style={{ display: 'flex' }}>
        <button onClick={() => submitScore(0)}>Submit 0</button>
        <button onClick={() => submitScore(1)}>Submit 100</button>
      </div> */}
    </div>
  )
}

export default memo(DevPanel);
